import { Grid, Button } from '@material-ui/core'
import { Link } from 'react-router-dom'

const ProductTeaser = ({ heading, description, image, imageOnRight, linkTo }) => {
  return (
    <Grid container className={imageOnRight ? 'product-teaser img-right' : 'product-teaser'}>
      <Grid item xs={12} sm={6}>
        <Grid item xs={12} className='teaser-image'>
          <img alt='green' src={image} />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid container item className='teaser-text'>
          <h2>{heading}</h2>
          <div className='description'>{description}</div>
          <Link to={linkTo}>
            <Button className='link-button'>Lue lisää</Button>
          </Link>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ProductTeaser
